import { Button, Drawer, Form, message, Select } from "antd";
import { useEffect } from "react";
import { usePermissions } from "../../../custom_hooks/permission/permission_hook";

const { Option } = Select;

interface WarehouseSelectionDrawerProps {
    visible: boolean;
    onFinish: (values: { vw_id: number }) => void;
    onClose: () => void;
}

export const md_warehouse_mapping = [
    { id: 578, name: "Rebound Exports" },
    { id: 721, name: "Horamavu Exports" },
    { id: 722, name: "Hyderabad Exports" },
];

const WarehouseSelectionDrawer = ({
    visible,
    onFinish,
    onClose,
}: WarehouseSelectionDrawerProps) => {
    const [form] = Form.useForm();
    const { hasPermission } = usePermissions();
    const canEdit = hasPermission("delivery.update");

    useEffect(() => {
        if (visible) {
            form.resetFields();
        }
    }, [visible, form]);

    const onSubmit = () => {
        if (!canEdit) {
            message.error("You don't have permission to select a warehouse");
            return;
        }
        form.validateFields().then((values) => {
            onFinish(values);
        });
    };

    return (
        <Drawer
            title="Select Warehouse"
            placement="right"
            open={visible}
            closable={true}
            onClose={onClose}
            width={400}
            footer={
                <div className="d-flex gap-2">
                    <Button onClick={onClose}>Cancel</Button>
                    <Button type="primary" onClick={onSubmit} disabled={!canEdit}>
                        Save
                    </Button>
                </div>
            }
        >
            <Form form={form} layout="vertical" onFinish={onSubmit}>
                <Form.Item
                    name="vw_id"
                    label="Warehouse"
                    rules={[{ required: true, message: "Please select a warehouse" }]}
                >
                    <Select placeholder="Select a warehouse">
                        {md_warehouse_mapping.map((warehouse) => (
                            <Option key={warehouse.id} value={warehouse.id}>
                                {warehouse.name}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>
            </Form>
        </Drawer>
    );
};

export default WarehouseSelectionDrawer;
